import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, TextField } from "@mui/material";
import { NewRequestMetadataInputProps } from "../new-request-metadata-input";

const NewRequestInputTitles = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, isErrored, onChange } = props;

  return (
    <Autocomplete
      id={metadata.tagName!}
      // options management
      options={[]}
      // value management
      value={value?.map((el) => el.text) || []}
      onChange={(e, value) => onChange(value)}
      // render input
      multiple
      freeSolo
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => <TextField error={isErrored} sx={{ mt: "-24px" }} {...params} />}
    />
  );
};

export default NewRequestInputTitles;
